// @flow

import moment from 'moment';

import type { Shift } from '../../common/typings';

export default function whenIsNextAvailableClockIn(
  shift: Shift,
  clockInEarlyMinutes: number
): string {
  const milisecondsTillClockIn =
    new Date().getTime() - (shift.dtstartLocal.getTime() - clockInEarlyMinutes * 60 * 1000);
  const minutesTillClockIn = milisecondsTillClockIn / (60 * 1000);
  const when = moment.duration(minutesTillClockIn, 'minutes').humanize();
  return `You will be able to clock in after ${when}`;
}
